import {createApp} from 'vue'
import App from './App.vue'
import router from './router';
import store from './store';

// ElementPlus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'

// 全局引入样式文件 tailwindcss
import '@/assets/input.css'

// 阿里图标
import '@/assets/icon/ali_iconfont.css'

/*
全局组件
 */
// 后台-按钮边框
import rightToolbar from "@/components/rightToolbar/index.vue";
// 加载
import Loading from '@/components/comment/loading/loading'

// 加载vuex状态数据
import {initVuex} from "@/utils/initVuex";

initVuex()

const app = createApp(App)

/*
全局组件
 */
//  rightToolbar 组件
app.component('rightToolbar', rightToolbar);

app.use(router)
    .use(store)
    .use(ElementPlus, {locale: zhCn})
    .use(Loading)
    .mount('#app')
